import { Menu, X } from 'lucide-react'

import { IMobileNavProps } from './MobileNav.types'
import * as S from './MobileNav.styles'

import { Sheet, SheetTrigger } from '@/components/ui/Sheet'
import { SideNav, type NavItemType } from '@/components/common/SideNav'

export const MobileNav = ({ userType, currentItem, onNavigate, isOpen, onOpenChange }: IMobileNavProps) => {
    const handleNavigate = (item: NavItemType) => {
        onNavigate(item)
        onOpenChange(false) // Close drawer after navigation
    }

    return (
        <Sheet open={isOpen} onOpenChange={onOpenChange}>
            <SheetTrigger asChild>
                <S.MenuButton aria-label="Open navigation menu">
                    <Menu className="h-5 w-5" />
                </S.MenuButton>
            </SheetTrigger>
            <S.StyledSheetContent side="left" aria-describedby="mobile-navigation-description">
                <S.ScreenReaderText id="mobile-navigation-description">Mobile navigation menu</S.ScreenReaderText>

                {/* Header with close button */}
                <S.NavHeader>
                    <S.NavTitle>Navigation</S.NavTitle>
                    <S.CloseButton onClick={() => onOpenChange(false)}>
                        <X className="h-4 w-4" />
                    </S.CloseButton>
                </S.NavHeader>

                {/* Navigation Content */}
                <S.NavContent>
                    <SideNav
                        userType={userType}
                        currentItem={currentItem}
                        onNavigate={handleNavigate}
                        isExpanded={true}
                        isMobile={true}
                    />
                </S.NavContent>
            </S.StyledSheetContent>
        </Sheet>
    )
}
